/**
 * Café renovation: bought one after another with stars earned in levels.
 * Positions are in room-image pixels (cafe_room_empty is 1024 × 1536);
 * `anchor` follows DESIGN_SPEC §11 (floor items bottom centre, lamp at the
 * ceiling mount, rug centred). `width` is the size in the room – sheet
 * sizes are not real proportions.
 */
export interface CafeItem {
  id: string;
  name: string;
  /** atlas frame; null = special (wall repair) */
  frame: string | null;
  cost: number;
  x: number;
  y: number;
  width: number;
  anchor: [number, number];
  /** draw order inside the room (low = further back) */
  layer: number;
}

export const CAFE_ITEMS: CafeItem[] = [
  { id: 'walls', name: 'Fresh walls', frame: null, cost: 1, x: 0, y: 0, width: 0, anchor: [0, 0], layer: 0 },
  { id: 'dog_bed', name: 'Cozy dog bed', frame: 'cafe_dog_bed', cost: 2, x: 250, y: 1010, width: 300, anchor: [0.5, 1], layer: 3 },
  { id: 'rug', name: 'Round rug', frame: 'cafe_rug', cost: 3, x: 590, y: 1050, width: 470, anchor: [0.5, 0.5], layer: 1 },
  { id: 'table', name: 'Table for two', frame: 'cafe_table_set', cost: 3, x: 230, y: 830, width: 330, anchor: [0.5, 1], layer: 2 },
  { id: 'counter', name: 'Café counter', frame: 'cafe_counter', cost: 4, x: 850, y: 870, width: 340, anchor: [0.5, 1], layer: 2 },
  { id: 'espresso', name: 'Espresso machine', frame: 'cafe_espresso_machine', cost: 4, x: 790, y: 668, width: 150, anchor: [0.5, 1], layer: 4 },
  { id: 'pastry', name: 'Pastry case', frame: 'cafe_pastry_case', cost: 5, x: 925, y: 668, width: 150, anchor: [0.5, 1], layer: 4 },
  { id: 'plant', name: 'Happy plant', frame: 'cafe_plant', cost: 5, x: 960, y: 1130, width: 150, anchor: [0.5, 1], layer: 5 },
  { id: 'lamp', name: 'Warm lamp', frame: 'cafe_pendant_lamp', cost: 6, x: 512, y: 0, width: 170, anchor: [0.5, 0], layer: 5 },
  { id: 'sign', name: 'Welcome sign', frame: 'cafe_sign', cost: 6, x: 110, y: 1150, width: 170, anchor: [0.5, 1], layer: 5 },
];

export const cafeItem = (id: string) => CAFE_ITEMS.find((i) => i.id === id)!;
